<template>
  <v-row class="gadient-auth" align="center" justify="center" style="height: 100vh">
    <v-card class="pa-3" width="480">
      <v-card-title>
        <v-sheet width="100%">
          <img class="ml-1 my-3" :src="require('@/assets/appLogo-color--Onlight.svg')" height="48">
          <span class="d-block ml-1 mt-2 mb-1 heading-3 text--secondary font-weight-medium">
            <template v-if="this.$route.query.invitation">Aceptar la invitación</template>
            <template v-else>Crear una cuenta</template>
          </span>
        </v-sheet>
      </v-card-title>
      <v-card-text class="py-0">
        <v-form>
          <v-col class="pa-0" v-if="!this.$route.query.invitation">
            <span class="ml-1 body-2 text--secondary font-weight-medium">Email</span>
            <v-text-field v-model="user.email" @keyup.enter="signUp" :error="$v.user.email.$error" outlined hide-details ref="emailField" required single-line dense maxlength="254" />
          </v-col>
          <v-col :class="`${$v.user.password1.minLength ? 'my-6' : 'mt-6 mb-3'} pa-0`">
            <span class="ml-1 body-2 text--secondary font-weight-medium">Contraseña</span>
            <v-text-field class="icon-field" v-model="user.password1" @keyup.enter="signUp" :error="$v.user.password1.$error" @click:append="show1 = !show1" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'user.password1' : 'password'" outlined :hide-details="$v.user.password1.minLength" persistent-hint ref="passwordField" required single-line dense maxlength="20" autocomplete="new-password" hint="Escribe al menos 8 caracteres." />
          </v-col>
          <v-col class="pa-0 my-6">
            <span class="ml-1 body-2 text--secondary font-weight-medium">Confirmar Contraseña</span>
            <v-text-field class="icon-field" v-model="user.password2" @keyup.enter="signUp" :error="$v.user.password2.$error" @click:append="show = !show" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'user.password2' : 'password'" outlined :hide-details="$v.user.password2.sameAsPassword" persistent-hint required single-line dense maxlength="20" autocomplete="new-password" hint="La contraseña debe ser igual." />
          </v-col>
          <v-col class="pa-0 check">
            Al {{ this.$route.query.invitation ? ' iniciar sesión' : 'crear la cuenta'}} aceptas nuestros
            <a class="checkLink font-weight-medium" target="_blank" :href="`${$DOCS_BASE}/terms/`">términos de uso y política de privacidad.</a>
          </v-col>
          <v-col v-if="error" class="pa-0 text-center">
            <v-alert border="left" colored-border color="white" dense class="body-2 red--text pa-0">{{error}}</v-alert>
          </v-col>
          <v-col class="my-6 pa-0">
            <v-btn @click="signUp" :loading="signUpLoader" retain-focus-on-click color="primary" height="40" dark block :ripple="false">{{this.$route.query.invitation ? 'Unirse' : 'Comenzar'}}</v-btn>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4 pt-1">
        <v-sheet class="text-center py-3" color="background" rounded width="100%">
          <span class="d-block body-2 text--primary">¿Ya tienes una cuenta Piriod?</span>
          <v-btn :to="{name: 'AuthSignIn'}" text color="primary" :ripple="false">Inicia sesión</v-btn>
        </v-sheet>
      </v-card-actions>
    </v-card>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, requiredIf, email, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    user: {
      email: '',
      password1: '',
      password2: ''
    },
    show: false,
    show1: false,
    error: '',
    signUpLoader: false
  }),
  computed: mapState({
    invitation: state => state.auth.invitation
  }),
  created () {
    if (this.$store.state.auth.user.authenticated) {
      this.$router.push({
        name: 'AccountDashboard'
      })
    }

    // set email if there is an invitation or user
    // comes from a landing page
    if (this.$route.query.email) {
      this.user.email = this.$route.query.email
    }
  },
  mounted () {
    // focus on email field if there is no invitation
    // or user comes from a landing page
    if (this.user.email) {
      this.$nextTick(() => this.$refs.passwordField.focus())
    } else {
      this.$refs.emailField.focus()
    }
  },
  methods: {
    identifyUser () {
      /**
       * retrieve user data to identify user
       * it runs as long as the env is production
       */
      if (process.env.NODE_ENV !== 'production') {
        return false
      }

      this.$store.dispatch('auth/GET_USER')
      .then((r) => {
        const traits = {
          email: r.data.email
        }

        const options = {
          integrations: {
            Intercom: {
              user_hash: r.data.intercom.hash
            }
          }
        }

        this.$analytics.identify(r.data.email, traits, options)
      })
    },
    signUp () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.signUpLoader = true

      return new Promise((resolve, reject) => {
        if (this.$route.query.invitation) {
          this.$store.dispatch('auth/ACCEPT_INVITATION', this.$route.query.invitation)
          .then((response) => {
            this.user.email = response.data.account_verified_email
            resolve()
          })
          .catch((error) => {
            this.$dialog.message.error(error.response.data.detail)
            reject(this.error)
          })
        } else {
          resolve()
        }
      })
      .then((response) => {
        this.$store.dispatch('auth/SIGN_UP', {
          user: this.user,
          invitation: this.$route.query.invitation
        })
        .then(() => {
          this.$store.dispatch('auth/GET_AUTH', {
            resource: '/token/',
            payload: {
              username: this.user.email,
              password: this.user.password1
            }
          })
          .then(() => {
            this.identifyUser()
            this.$store.dispatch('onboarding/RESET')
            this.$router.push({ name: 'UserOnboarding' })
          })
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.email[0])
        })
      })
      .finally(() => {
        this.signUpLoader = false
      })
    }
  },
  validations: {
    user: {
      email: {
        required: requiredIf(function () {
          return !this.$route.query.invitation
        }),
        email,
        maxLength: maxLength(254)
      },
      password1: {
        required,
        minLength: minLength(8)
      },
      password2: {
        sameAsPassword: sameAs('password1')
      }
    }
  }
}
</script>